import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Table, Row, Col, Image } from 'react-bootstrap';
import Player from '../components/Player';
import HeaderImage from '../components/HeaderImage';
import config from '../const/config';
import './Music.scss';

class Band extends Component {
  renderSong(s) {
    return (
      <li key={s.repId} className="p-3 mr-5 song">
        <div>{s.song.songName}</div>
        <div>{s.song.songArtistName}</div>
      </li>
    );
  }
  renderSongs(isSka) {
    const songs = [];
    let category, currentCategory;
    this.props.songlist.forEach(s => {
      currentCategory = s.song.catId;
      if ((isSka && currentCategory === 14) || (!isSka && currentCategory !== 14)) {
        const newCategory = currentCategory !== category;
        category = currentCategory;
        if (newCategory) {
          songs.push(
            <li key={s.song.catId} className="category py-3 mr-5 mt-4">
              <div className="category-name p-2 d-inline-block">{s.song.category.catDescription}</div>
            </li>
          );
        }
        songs.push(this.renderSong(s));
      }
    });
    return songs;
  }

  render() {
    return (
      <div className="Music">
        <HeaderImage heading="THE MUSIC" imgSrc="media.jpg" darken={0.5} checkTop checkBottom />
        <Container className="content py-4 px-5" fluid>
          <h3>SONG LIST</h3>
          <hr />
          <Row className="mt-5">
            <Col className="audio-container">
              <div className="position-relative">
                <Image src="/images/audio.jpg" fluid />
                <div className="d-flex justify-content-center align-items-center audio-box position-absolute">
                  <h4>AUDIO SAMPLES</h4>
                </div>
              </div>
            </Col>
            <Col>
              <Table className="mp3s">
                <tbody>
                  {this.props.mp3s &&
                    this.props.mp3s.map(x => <Player url={`${config.blobUrl}/mp3s/${x.upload.fileName}`} songName={x.upload.altText} key={x.uploadId} />)}
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row>
            <Col>
              <ul className="songlist mt-5">{this.props.songlist && this.renderSongs(true)}</ul>
            </Col>
            <Col>
              <ul className="songlist mt-5">{this.props.songlist && this.renderSongs(false)}</ul>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default connect(state => ({ mp3s: state.mp3s, songlist: state.songlist }))(Band);
